'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardWebhooksCtrl', ['$uibModal', '$state', 'webhooks',require('./dashboardWebhooksCtrl')]);
app.directive('webhooks', [require('./dashboardWebhooksDirective')]);
app.config(['$stateProvider', require('./dashboardWebhooksConfig')]);